import TrainerPage from "./TrainerPage";

export default TrainerPage;
